import { EmailToSupplierContactPersonData } from '../../EmailToSupplierForm.types';

export const getNewEmailValues = (values: string[], emailOptions: EmailToSupplierContactPersonData[]) =>
    values.reduce<EmailToSupplierContactPersonData[]>((acc, value) => {
        const item = emailOptions.find((email) => email.id === value);

        if (item) {
            acc.push(item);
        } else {
            acc.push({
                id: value,
                text: value,
                firstName: '',
                lastName: '',
                emailAddress: value,
                includeInEmails: true,
            });
        }

        return acc;
    }, []);
